
const types = {

    HTTP_PENDING_DMO_IMPORTER: 'HTTP_PENDING_DMO_IMPORTER',
    HTTP_ERROR_DMO_IMPORTER: 'HTTP_ERROR_DMO_IMPORTER',
    HTTP_SUCCESS_DMO_IMPORTER: 'HTTP_SUCCESS_DMO_IMPORTER',

   
}
const actions = {
    //HTTP
    startHTTPRequest: () => ({
        type: types.HTTP_PENDING_DMO_IMPORTER,
    }),
    stopHTTPRequestError: (error) => ({
        type: types.HTTP_ERROR_DMO_IMPORTER,
        error: error
    }),
    stopRequestSuccess: (payload) => ({
        type: types.HTTP_SUCCESS_DMO_IMPORTER,
        payload: payload
    }),

    
}



export { types, actions };
